<template>
	<b-card class="quoterCard p-0">
    <div class="w-100 button-with-alert">
      <span :title="disabledButton ? $t('Debes completar los campos País y Courier') : $t('Agregar lista')" v-b-tooltip.bottom.hover class="float-right">
        <b-button variant="warning" @click="openModal('ModalAddList')" :disabled="disabledButton"> <feather-icon icon="UploadFileIcon" /> Agregar Lista </b-button>
      </span>
    </div>
		<form-render
			ref="formRenderPricesLists"
			:key="keyPricesLists"
			:fields="fields"
			:form.sync="form"
			@send="sendForm()"
			:buttonSend="buttonSend"
			containerButtonsClass="col-sm-12 col-md-4 col-lg-4 mt-2 mb-4 pl-0 pr-0"
		>
			<template #buttons>
				<b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" class="ml-1 mr-1" @click="cleanFilter">
					<feather-icon icon="RefreshCwIcon" />
				</b-button>
        <b-button variant="link" class="assign--buttons--link" @click="openModalFilters('ModalAdvanceFiltersPricesLists')">Búsqueda avanzada</b-button>
			</template>
		</form-render>
		<div v-if="loading.pricesLists && showTable">
			<b-skeleton height="40px" width="`calc(100vh - 2.5rem)`" class="mt-1 mb-1" />
			<div class="table-skeleton-tableQuoter">
				<b-skeleton-table :rows="5" :columns="6" :table-props="{ }" />
			</div>
		</div>
		<TablePricesLists
			v-if="!loading.pricesLists && showTable"
			:rows="rows"
      :formCountryCourier="form"
      :mySession="mySession"
		></TablePricesLists>
    <ModalAddList v-if="openModalAddList" @getLists="sendForm" :formCountryCourier="form" :mySession="mySession"></ModalAddList>
    <ModalAdvanceFiltersPricesLists
      v-if="isOpenModalAdvanceFiltersPricesLists"
      :dataFilters="dataFilters"
      :form.sync="form"
      @closeModal="closeModal"
      @sendFormData="sendForm"
    />
	</b-card>
</template>
<script>
import { mapGetters } from 'vuex'
import ModalAddList from './components/ModalAddList.vue'
import TablePricesLists from './components/TablePricesLists.vue'
import BaseServices from '@/store/services/index'
import ModalAdvanceFiltersPricesLists from './components/ModalAdvanceFiltersPricesLists.vue'

export default {
  components: { ModalAddList, TablePricesLists, ModalAdvanceFiltersPricesLists },
  name: 'PricesLists',
  props: {
    mySession: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      baseService: new BaseServices(this),
      keyPricesLists: 0,
      form: {},
      fields: [],
      buttonSend: { icon: 'SearchIcon', title: 'Buscar', color: 'warning', disabled: false },
      loading: {
        pricesLists: false
      },
      showTable: false,
      openModalAddList: false,
      rows: [],
      disabledButton: true,
      isOpenModalAdvanceFiltersPricesLists: false,
      dataFilters: {}
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getCountriesInCurrentCoverage',
      carriers: 'getCarriersForCountry',
      services: 'getServicesByCountryCarrier',
      generalLoading: 'getLoading'
    })
  },
  watch: {
    countries() {
      this.setOptions('countries', 'country')
      const resetFields = ['country', 'carrier']
      resetFields.forEach(el => this.setSkeletonField(el, false))
    },
    carriers() {
      this.setOptions('carriers', 'carrier')
      const resetFields = ['carrier']
      resetFields.forEach(el => this.setSkeletonField(el, false))
    },
    services() {
      this.form.servicesOptions = this.services.rows
    },
    'pagination.page' () {
      this.getList()
    },
    'pagination.limit' () {
      this.getList()
    },
    generalLoading: {
      handler () {
        this.loading.countries = !!this.generalLoading.getCountriesInCurrentCoverage
        this.loading.carriers = !!this.generalLoading.getCarriersForCountry
      },
      deep: true
    }
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    setInitialData () {
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'country', disabled: false, label: 'País', containerClass: 'col-sm-12 col-md-3 col-lg-3 fieldSelect', change: this.changeCountry, addFlags: true, validation: 'required', sort: true },
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'carrier', label: 'Courier', containerClass: 'col-sm-12 col-md-3 col-lg-3', dependency: 'country', sort: true, validation: 'required', change: this.changeCourier}
      ]
      this.$store.dispatch('fetchService', { name: 'getCountriesInCurrentCoverage' })
    },
    setOptions(name, fieldName) {
      this.fields[this.m_getElementIndex(this.fields, 'name', fieldName)].options = this[name].rows
    },
    setSkeletonField (name, bool) {
      this.fields[this.m_getElementIndex(this.fields, 'name', name)].useSkeleton = bool
      this.fields[this.m_getElementIndex(this.fields, 'name', name)].useLabel = bool
    },
    changeCountry(name, value) {
      if (value) {
        this.setSkeletonField('carrier', true)
        this.$store.dispatch('fetchService', { name: 'getCarriersForCountry', params: { country_id: value.id } })
      }
      delete this.form.carrier
      this.rows = []
      this.showTable = false
    },
    changeCourier(name, value) {
      this.disabledButton = !value
      if (value) {
        const params = { country_id: this.form.country.id, carrier_id: this.form.carrier.id}
        this.$store.dispatch('fetchService', { name: 'getServicesByCountryCarrier', params})
      }
      this.rows = []
      this.showTable = false
    },
    sendForm(value = {}) {
      const getField = (field) => value?.[field] || this.form?.[field]

      const params = {}
      const queryParams = {}

      const country = getField('country')
      const carrier = getField('carrier')
      const service = getField('service')
      const idSeller = getField('idSeller')

      if (carrier?.id) {
        params.carrier_id = carrier.id
        queryParams.carrier_id = carrier.id
      }
      if (country?.id) queryParams.country_id = country.id
      if (service?.id) {
        queryParams.carrier_service_id = service.id
        this.form.service = service
      }
      if (idSeller?.parent_id) {
        this.form.idSeller = idSeller
        queryParams.parent_company_id = idSeller.parent_id
      }

      this.showTable = true
      this.loading.pricesLists = true
      this.baseService.callService('getPricesListsByCarrier', {}, params)
        .then(response => {
          this.rows = response.data
        })
        .catch((err) => {
          this.$newError('Ha ocurrido un problema', err.message, 'large')
        })
        .finally(() => {
          this.loading.pricesLists = false
        })
    },
    cleanFilter() {
      this.showTable = false
      this.disabledButton = true
      this.form = {}
    },
    openModal(name) {
      this.openModalAddList = true
      this.$nextTick(() => {
        this.$bvModal.show(name)
      })
    },
    openModalFilters(modal) {
      this[`isOpen${modal}`] = true
      this.dataFilters = {
        countries: this.countries.rows,
        form: this.form
      }
      this.$nextTick(() => {
        this.$bvModal.show('ModalAdvanceFiltersPricesLists')
      })
    },
    showTableManageVersions() {
      this.showTableVersions = !this.showTableVersions
    },
    closeModal(modal) {
      this[`isOpen${modal}`] = false
      this.$bvModal.hide(modal)
    }
  }
}
</script>
<style scoped>
</style>